<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-12 mb-2 py-3">
    <div class="col-xs-12 col-md-12 mb-5">
      <h2 class="mb-4 c-form-title">
        {{ "userRegistration.userInformation.header" | cxTranslate }}
      </h2>
      <p class="text-fixed-legal-copy">
        {{ "userRegistration.userInformation.formTitle" | cxTranslate }}
      </p>
    </div>

    <form [formGroup]="userInfoForm" id="userInfoForm" (ngSubmit)="submitUserInfo()">
      <div class="row mb-2">
        <div id="registerBilling" class="col-xs-12 col-md-12">
          <div formGroupName="userInfoDetails">
            <!-- Username -->
            <div class="col-xs-12 col-sm-12 col-md-6 c-text-input mb-3">
              <label for="username" class="Fields-label icon-label d-inline c-form-label">
                {{ "userRegistration.userInformation.username.label" | cxTranslate }}
              </label>

              <ng-template #popContent>
                {{ "userRegistration.userInformation.username.popover_msg_1" | cxTranslate }}
                <br /> {{ "userRegistration.userInformation.username.popover_msg_2" | cxTranslate }}
                <br /> {{ "userRegistration.userInformation.username.popover_msg_3" | cxTranslate }}
              </ng-template>

              <a placement="top" [ngbPopover]="popContent" class="d-inline">
                <i color="red" class="fa fa-question-circle c-icon-primary-sm"></i>
              </a>
              <input id="username" name="userName" data-valid="valid_facility"
                aria-labelledby="userName tooltipFacilityName" type="text" class="Fields-input user" autocomplete="off"
                formControlName="userName" data-di-id="#userName" />

              <cx-form-errors *ngIf="isUsernameExists && !userInfoForm.get('userInfoDetails.userName').touched"
                class="errorMessage">
                <p> {{ "userRegistration.userInformation.username.existingUsernameMsg" | cxTranslate }} </p>
              </cx-form-errors>

              <cx-form-errors *ngIf="
                !!userInfoForm.get('userInfoDetails.userName').value
                && !userInfoForm.get('userInfoDetails.userName').valid
                && userInfoForm.get('userInfoDetails.userName').errors?.sameAsaccountNo
                && userInfoForm.get('userInfoDetails.userName').touched" class="errorMessage">
                <p>
                  {{ "userRegistration.userInformation.username.usernameSameAsAccountNo" | cxTranslate }}
                </p>
              </cx-form-errors>

              <cx-form-errors *ngIf="
                !!userInfoForm.get('userInfoDetails.userName').value
                && !userInfoForm.get('userInfoDetails.userName').valid
                && !userInfoForm.get('userInfoDetails.userName').errors?.sameAsaccountNo
                && userInfoForm.get('userInfoDetails.userName').touched" class="errorMessage">
                <p>
                  {{ "userRegistration.userInformation.username.inValidUsername" | cxTranslate }}
                </p>
              </cx-form-errors>

              <cx-form-errors *ngIf="
                userInfoForm.get('userInfoDetails.userName').errors?.required
                && !userInfoForm.get('userInfoDetails.userName').valid
                && userInfoForm.get('userInfoDetails.userName').touched" class="errorMessage" role="alert"
                aria-live="assertive">
                <p>
                  {{ "userRegistration.userInformation.requiredMsg" | cxTranslate }}
                </p>
              </cx-form-errors>
            </div>
          </div>
        </div>
      </div>
      <!-- About Me -->
      <div class="col-xs-12 col-md-12 mb-2">
        <h2 class="mb-4 c-form-title">
          {{ "userRegistration.userInformation.subTitle" | cxTranslate }}
        </h2>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-12" id="registerBilling">
          <!-- First name -->
          <div class="col-xs-12 col-sm-12 col-md-6 c-text-input mb-3">
            <label for="userFirstName" class="c-form-label">
              {{ "userRegistration.userInformation.firstName.label" | cxTranslate }}
            </label>
            <input id="userFirstName" name="firstName" data-valid="valid_facility"
              aria-labelledby="firstName tooltipFacilityName" type="text" class="Fields-input" autocomplete="off"
              formControlName="firstName" data-di-id="#userFirstName" />

            <cx-form-errors *ngIf="
              userInfoForm.get('firstName').errors?.required
              && !userInfoForm.get('firstName').valid
              && userInfoForm.get('firstName').touched" class="defaultMessage" role="alert" aria-live="assertive">
              <p>
                {{ "userRegistration.userInformation.requiredMsg" | cxTranslate }}
              </p>
            </cx-form-errors>
          </div>
          <!-- Last name -->
          <div class="col-xs-12 col-sm-12 col-md-6 c-text-input mb-3">
            <label for="userLastName" class="c-form-label">
              {{ "userRegistration.userInformation.lastName.label" | cxTranslate }}
            </label>
            <input id="userLastName" name="lastName" data-valid="valid_facility"
              aria-labelledby="lastName tooltipFacilityName" type="text" class="Fields-input" autocomplete="off"
              formControlName="lastName" data-di-id="#userLastName" />

            <cx-form-errors *ngIf="
              userInfoForm.get('lastName').errors?.required
              && !userInfoForm.get('lastName').valid
              && userInfoForm.get('lastName').touched" class="defaultMessage" role="alert" aria-live="assertive">
              <p>
                {{ "userRegistration.userInformation.requiredMsg" | cxTranslate }}
              </p>
            </cx-form-errors>
          </div>
          <!-- Role -->
          <div class="row">
            <div class="col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-6 c-text-input mb-3">
                <label for="primaryRole" id="roleLabel" class="c-form-label">
                  {{ "userRegistration.userInformation.role.label" | cxTranslate }}
                </label>

                <cx-form-errors *ngIf="
                  userInfoForm.get('role').errors?.required
                  && !userInfoForm.get('role').valid
                  && userInfoForm.get('role').touched" class="errorMessage pt-2" role="alert" aria-live="assertive">
                  <p>
                    {{ "userRegistration.userInformation.requiredMsg" | cxTranslate }}
                  </p>
                </cx-form-errors>

                <ng-select
                  name="role"
                  [items]="contactRole"
                  [searchable]="false"
                  [clearable]="false"
                  bindLabel="name"
                  bindValue="code"
                  placeholder="{{
                    'accountRegistration.selectPlaceHolder' | cxTranslate
                  }}"
                  formControlName="role"
                  class="dropdown-credit mb-4"
                ></ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-md-12 mb-2">
        <h2 class="mb-4 c-form-title">
          {{ "userRegistration.userInformation.anotherSubTitle" | cxTranslate }}
        </h2>
      </div>
      <!-- email consent -->
      <div class="row">
        <div class="col-md-12">
          <div class="col-md-6 c-text-input mb-3">
            <label for="userEmailConsent" id="usrEmailConsentLabel" class="c-form-label mb-3">
              {{ "userRegistration.userInformation.emailConsent.label" | cxTranslate }}
            </label>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" class="custom-control-input" id="acceptEmailConsent" name="emailConsent"
                [value]="!isEmailConsent" formControlName="emailConsent" />
              <label class="custom-control-label radio_align" for="acceptEmailConsent">
                {{ "userRegistration.userInformation.emailConsent.accepted" | cxTranslate }}
              </label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" class="custom-control-input" id="rejectEmailConsent" name="emailConsent"
                [value]="isEmailConsent" formControlName="emailConsent" />
              <label class="custom-control-label radio_align" for="rejectEmailConsent">
                {{ "userRegistration.userInformation.emailConsent.rejected" | cxTranslate }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-12 mb-1">
          <div class="col-md-6 c-text-input">
            <div class="invoice-btngrps" [ngClass]="!!altEmailSection
              && userInfoForm.get('emailConsent').value
              ? 'alt-section'
              : ''">
              <button type="submit" class="c-button c-button--primary c-button--lg reviewvalidbtn"
                data-di-id="di-id-7a6cb2cd-cb37948a">
                {{ "userRegistration.userInformation.submit_button" | cxTranslate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>